import React from 'react';

const BusinessPersonalSection = ({ themeData }: any) => {
  return (
    <>
      {' '}
      <section className="serv-section" id="service-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title">
                <h2
                  style={{
                    color: `#${themeData?.theme_4?.home?.section_6?.h2color}`,
                  }}
                >
                  {themeData?.theme_4?.home?.section_6?.title}
                </h2>

                {/* <h2>service for Business & Personal</h2> */}
                <p
                  style={{
                    color: `#${themeData?.theme_4?.home?.section_6?.h3color}`,
                  }}
                >
                  {themeData?.theme_4?.home?.section_6?.paragraph}
                </p>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <div className="split-img">
                <img
                  src={themeData?.theme_4?.home?.section_6?.first_card_image}
                  alt=""
                />
              </div>
            </div>
            <div className="col-md-6">
              <div className="serv-content">
                <h4
                  style={{
                    color: `#${themeData?.theme_4?.home?.section_6?.h2color}`,
                  }}
                >
                  {themeData?.theme_4?.home?.section_6?.sub_title}
                </h4>

                <ul>
                  {themeData?.theme_4?.home?.section_6?.card_section?.collection.map(
                    (item: any) => {
                      return (
                        <>
                          <li
                            style={{
                              color: `#${themeData?.theme_4?.home?.section_6?.paracolor}`,
                            }}
                          >
                            {item?.collection_list}
                          </li>
                        </>
                      );
                    }
                  )}
                </ul>
              </div>
              <div className="serv-content">
                <h4
                  style={{
                    color: `#${themeData?.theme_4?.home?.section_6?.h2color}`,
                  }}
                >
                  {themeData?.theme_4?.home?.section_6?.sub_title_two}
                </h4>
                <ul>
                  {themeData?.theme_4?.home?.section_6?.card_section_two?.collection.map(
                    (item: any) => {
                      return (
                        <>
                          <li
                            style={{
                              color: `#${themeData?.theme_4?.home?.section_6?.paracolor}`,
                            }}
                          >
                            {item?.collection_list}
                          </li>
                        </>
                      );
                    }
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default BusinessPersonalSection;
